import '../../styles/App.css';
import MapRender from '../Map/MapRender.js'

export default function Map() {
        return (
            <>
                <div class="flex" id="map-block">
                    <h1>Live Map</h1>
                    <MapRender/>
                    <h1>Map time/whatever was here</h1>
                </div>
            </>
        )
}